import Vue from 'vue';
import Vuex from 'vuex';

import urlsAPI from '../../config/urlsAPI';
import handlerError from '../../utils/errors';
import { axiosInstance } from '../../main';

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    all: [],
  },
  mutations: {
    updateFailures(state, failures) {
      state.all = failures;
    },
    markAsSolved(state, id) {
      state.all = state.all.filter((failure) => failure.id !== id);
    },
  },
  actions: {

    async getFailures({ commit }) {
      return axiosInstance.get(urlsAPI.failuresURL)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateFailures', response.data);
          }
        })
        .catch(handlerError);
    },

    async solve({ commit }, id) {
      return axiosInstance.put(`${urlsAPI.failuresURL}${id}/solve`)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('markAsSolved', id);
          }
        })
        .catch(handlerError);
    },
  },
};
